/**
 * Shared event constants for cross-component communication in the MCP chat system.
 */

/** Fired by ProjectProvider after window.kuika.activeProjectId is set. */
export const PROJECT_LOADED_EVENT = "kuika-project-loaded";

/** Fired when saveChatState() exhausts all retries. */
export const CHAT_SAVE_FAILED_EVENT = "kuika-chat-save-failed";

/** Fired when a save succeeds after a prior failure (auto-dismiss trigger). */
export const CHAT_SAVE_RECOVERED_EVENT = "kuika-chat-save-recovered";
